@if (!loading) {
  <h3>My Provider Data Reviews</h3>
  @if (showPaginationHeader) {
    <app-pagination-header
      [paging]="paging"
      [label]="'reviews'"
      (pageSizeChange)="onPageSizeChange($event)"
    />
  }
  @if (dataReviews.length > 0) {
    <app-provider-data-review-list
      [dataReviews]="dataReviews"
      [selectedDataReviewIds]="selectedDataReviewIds"
      [totalCount]="paging.count"
      [showAssignedToCol]="false"
      (providerDataReviewSelected)="onProviderDataReviewSelected($event)"
      (providerDataReviewDeselected)="onProviderDataReviewDeselected($event)"
      (assignmentUpdate)="onAssignmentUpdate($event)"
      (assignmentClearSelection)="onAssignmentClearSelection()"
    />
    <div class="mt-2">
      <app-pagination [paging]="paging" (pageChange)="onPageChange()" />
    </div>
  } @else {
    <p class="ms-1">No provider data reviews requiring review.</p>
  }
} @else {
  <div class="ms-1"><mat-spinner diameter="30" /></div>
}